<template>
	<v-app>
		<v-main>
			<template v-if="!updateAvailable">
				<router-view></router-view>
			</template>
			<div v-else>
				<img src="./assets/images/perfecta_full_logo.png" class="update-img">
				<h2 class="update-available update-title">Ny version tillgänglig</h2>
				<h3 class="update-available update-under">Hämta uppdatering!</h3>
				<v-btn
					color="addStuff"
					tile
					block
					@click="refresh"
				>
					Tryck här
				</v-btn>
				<!--<job/>-->
			</div>
		</v-main>

		<v-snackbar
			app
			v-model="showUpdateSnackbar"
			multi-line
			color="primary"
			top
			:right="!$vuetify.breakpoint.mobile"
			timeout="-1"
		>
			Ny version tillgänglig
			<template v-slot:action="{ attrs }">
				<v-btn
					color="blue"
					text
					v-bind="attrs"
					@click="refresh"
				>
					Hämta uppdatering!
				</v-btn>
			</template>
		</v-snackbar>
	</v-app>
</template>

<script>

import Vue from 'vue';

export default {
	name: 'App',

	data: () => ({
		mobileBreakPoint: 960,
		drawer: false,
		mini: false,
		showUpdateSnackbar: false,
		updateAvailable: false
	}),
	created() {
		document.addEventListener('swUpdated', this.showAvailableUpdateSnack, { once: true })
        navigator.serviceWorker.addEventListener('controllerchange', () => {
            console.log('controllerchange');
            if (this.refreshing) return;
            console.log('refreshing');
            this.refreshing = true;
            window.location.reload();
        });
		Vue.prototype.$version = this.version;
		let jobId = this.$route && this.$route.query && this.$route.query.job;
        let accessToken = this.$route && this.$route.query && this.$route.query.access_token;
		if (jobId && accessToken) {
			Vue.prototype.$jobId = jobId;
			Vue.prototype.$accessToken = accessToken;
			this.$router.push({ path: '/job',  query: { job: jobId, access_token: accessToken } }).catch(error => {
				if (error.name != "NavigationDuplicated") {
					throw error;
				}
			});
		} else {
			this.$router.push({ path: '/'}).catch(error => {
				if (error.name != "NavigationDuplicated") {
					throw error;
				}
			})
		}
	},
	methods: {
		showAvailableUpdateSnack(event) {
			this.registration = event.detail;
			this.showUpdateSnackbar = true;
			this.updateAvailable = true;
		},
		refresh() {
			this.updateAvailable = false;
			this.showUpdateSnackbar = false;
			if (!this.registration) {
				console.error("Can't refresh - No registration");
				return;
			}
			if (!this.registration.waiting) {
				console.error("Can't refresh - Registration is not waiting");
				return;
			}
			console.log("Skip waiting");
			this.registration.waiting.postMessage("skipWaiting");
		}
	},
	computed: {
		version: {
			cache: false,
			get() {
				try {
					return require("../package.json").version;
				} catch (error) {
					console.error("couldn't load package version", error);
					return null;
				}
			}
		}
	},
	components: {

	}
};
</script>
<style lang="scss">
// if necessary
@import '~vuetify/src/styles/settings/_variables';

#app {
	font-family: Roboto, sans-serif !important;

	.version {
		position: fixed;
		bottom: 10px;
		left: 20px;
		font-size: 13px;
	}

	.v-card { background-color: #ffffff !important; }
	.fade-enter-active,
	.fade-leave-active {
		transition-duration: 0.1s;
		transition-property: opacity;
		transition-timing-function: ease;
	}

	.fade-enter,
	.fade-leave-active {
		opacity: 0;
	}
	.v-navigation-drawer.theme--dark,
	.v-footer.theme--dark {
		background: #0a2233;
	}
	.router-link { cursor: pointer; }
	h1, h2, h3, h4, h5 {
		font-family: Roboto, sans-serif;
		h3, h4, h5 {
			font-weight: 300;
		}
	}
	.bold {
		font-weight: bold;
	}
	.label {
		float: left;
		white-space: pre-wrap;
		margin: 0px;
	}
	.border {
		border-style: solid;
		border-width: 1px;
	}
	input {
		font-size: 16px;
	}
	.asset {
		font-size: 16px;
		border-radius: 8px;
		border-style: solid;
		border-width: 1px;
		border-color: grey;
		text-decoration: none;
	}
	.bottom {
		margin-bottom: 20px;
	}
	.version {
    position: fixed;
    bottom: 10px;
    left: 20px;
    font-size: 13px;
	}
	.bollar {
		width: 10px;
		height: 10px;
	}
	.bollar-container {
		width: 20px;
		margin-right: 5px;
	}
	.powered-by {
		position: fixed;
		bottom: 10px;
		right: 20px;
		font-size: 13px;
	}
	.footer {
		margin-top: 30px;
	}
	.toolbar-title {
        font-weight: bold;
        font-size: 26px;
    }
	.header-row {
		background: rgb(222, 222, 222);
		border-bottom: 2px solid;
		border-top: 2px solid;
		border-color: #cf2e2e;
	}
	.container {
        margin-top: 20px;
        margin-bottom: 20px;
        border: 1px solid grey;
        border-radius: 5px;
    }
	.row-background {
        background-color: #f5f5f5;
    }
	.keep-text-format {
		white-space: pre-wrap;
	}
	.update-available {
		text-align: center;
	}
	.update-title {
		margin-top: 20px;
	}
	.update-under {
		margin-bottom: 20px;
	}
	.update-img {
		width: 100%;
		margin-top: 20px;
	}
}
</style>
